export const assetStatusTypes = {
  GET_ASSET_STATUS_LOADING: "GET_ASSET_STATUS_LOADING",
  GET_ASSET_STATUS_SUCCESS: "GET_ASSET_STATUS_SUCCESS",
  GET_ASSET_STATUS_ERROR: "GET_ASSET_STATUS_ERROR",
  SET_ASSET_STATUS_COUNT: "SET_ASSET_STATUS_COUNT",
};
